import React from 'react'
import { PropTypes } from 'prop-types'
import { get } from 'lodash'
import { FormData, Status } from 'components/misc'

const OrganizationSummary = ({ data }) => {
  return (
    <div className="row">
      <div className="col-xs-4">
        <FormData label="State" intlKey="label.state">
          <Status state={get(data, 'organizationState')} />
        </FormData>
      </div>
    </div>
  )
}

OrganizationSummary.propTypes = {
  data: PropTypes.object
}

export default OrganizationSummary
